<template>
  <div>
    <h3>Printer List</h3>
    <b-table striped hover :fields="fields" :items="printers">
      <template slot="actions" slot-scope="cell">
        <b-button-group>
          <click-confirm>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click.stop="deletePrinter(cell.item)"
            >
              <icon name="remove" class="align-middle"></icon>
            </b-button>
          </click-confirm>
        </b-button-group>
      </template>
    </b-table>
  </div>
</template>

<script>
import Notify from "@/notify";
import ClickConfirm from "click-confirm";

export default {
  components: {
    "click-confirm": ClickConfirm,
  },
  mixins: [Notify],
  props: ["printers"],
  data() {
    return {
      fields: ["description", "ticket_type", "actions"],
    };
  },
  methods: {
    deletePrinter(printer) {
      this.$emit("deletePrinter", printer);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/printers/PrintGroupPrintersList.vue